import { render } from "./Depreciation_history_asset_wise.vue?vue&type=template&id=fc756450&scoped=true"
import script from "./Depreciation_history_asset_wise.vue?vue&type=script&lang=js"
export * from "./Depreciation_history_asset_wise.vue?vue&type=script&lang=js"

import "./Depreciation_history_asset_wise.vue?vue&type=style&index=0&id=fc756450&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc756450"]])

export default __exports__